import { createReducer } from "@reduxjs/toolkit"
import * as qualityCertificationActions from '../actions/qualityCertification'
import { APIData, APIStatus } from "../axiosConfiguration"
import { QualityCertificationData, QualityCertificationDocuments } from "../type/qualityCertification"

type qualityCertificationState = {
    qualityCertification: APIData<QualityCertificationData>,
    qualityCertificationDocumentData: APIData<QualityCertificationDocuments>
}

const initialState: qualityCertificationState = {
    qualityCertification: { status: APIStatus.IDLE },
    qualityCertificationDocumentData: { status: APIStatus.IDLE },
}

export default createReducer(initialState, (builder) => {
    builder
        .addCase(qualityCertificationActions.getQualityCertificationList.fulfilled, (state, action) => {
            state.qualityCertification.status = APIStatus.FULFILLED
            state.qualityCertification.data = action.payload
        })
        .addCase(qualityCertificationActions.getQualityCertificationList.rejected , (state, action) => {
            state.qualityCertification.status = APIStatus.REJECTED
            state.qualityCertification.error = action.payload
        })
        .addCase(qualityCertificationActions.getQualityCertificationList.pending, (state, action) => {
            state.qualityCertification.status = APIStatus.PENDING
        })
    
    builder
        .addCase(qualityCertificationActions.getQualityCertificationDocument.fulfilled, (state, action) => {
            state.qualityCertificationDocumentData.status = APIStatus.FULFILLED
            state.qualityCertificationDocumentData.data = action.payload
        })
        .addCase(qualityCertificationActions.getQualityCertificationDocument.rejected , (state, action) => {
            state.qualityCertificationDocumentData.status = APIStatus.REJECTED
            state.qualityCertificationDocumentData.error = action.payload
        })
        .addCase(qualityCertificationActions.getQualityCertificationDocument.pending, (state, action) => {
            state.qualityCertificationDocumentData.status = APIStatus.PENDING
        })
    
})